import React, { useEffect } from "react";
import AceEditor from "react-ace";
import { KTextInput, KDialog } from "@kyburz/kdesign-system";
import useSafeSetState from "../hooks/useSafeSetState";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";

interface Props {
  label?: string;
  value?: any;
  handleSubmit: (v) => void | any;
  style?: any;
}

const JsonTextInput = ({
  label = "",
  value = {},
  handleSubmit,
  style = {},
}: Props) => {
  const [{ open, code }, setState] = useSafeSetState({
    open: false,
    code: "",
  });

  const toggleOpen = () => setState({ open: !open });

  const handleCodeChange = (e) => setState({ code: e });

  const submit = () => {
    handleSubmit(JSON.parse(code));
    toggleOpen();
  };

  useEffect(() => {
    handleCodeChange(JSON.stringify(value, null, 2));
  }, [value]);

  const JsonPopup = (
    <KDialog
      size="md"
      title={label}
      open={open}
      primaryCTAonClick={submit}
      primaryCTAText="Save"
      primaryCTAColor="primary"
      onClose={toggleOpen}
      secondaryCTAColor="secondary"
      secondaryCTAonClick={toggleOpen}
      secondaryCTAText="Cancel"
    >
      <AceEditor
        placeholder="Transformations"
        mode="json"
        width="900px"
        theme="textmate"
        name="transformations"
        onChange={handleCodeChange}
        fontSize={14}
        showPrintMargin={true}
        showGutter={true}
        highlightActiveLine={true}
        value={code}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
        }}
      />
    </KDialog>
  );

  return (
    <div style={style}>
      <KTextInput
        onChange={() => {}}
        label={label}
        endIcon="code"
        onClick={toggleOpen}
        value={JSON.stringify(value)}
      />
      {JsonPopup}
    </div>
  );
};

export default JsonTextInput;
